import { computed } from "vue";
import { defineStore, storeToRefs } from "pinia";
import useCotizacionEstandarSourcesStore from "@/store/cotizaciones/estandar/sources";
import useCotizacionEstandarLeaseParametersStore from "@/store/cotizaciones/estandar/lease-parameters";

const useCotizacionEstandarUsesStore = defineStore("cotEstUses", () => {
  const { sources } = storeToRefs(useCotizacionEstandarSourcesStore());

  const { leaseParameters } = storeToRefs(
    useCotizacionEstandarLeaseParametersStore()
  );

  const uses = computed(() => {
    const conceptos = {
      paymentToOEM: leaseParameters.value.equipmentValueBeforeNet.value,
      vatOnEquipment: leaseParameters.value.vatMonto.value,
      servicerFeeOpening: leaseParameters.value.openingFeeMonto.value,
      servicerFeeOpeningVat: sources.value.servicerFees.vatOpeningFee.total,
      firstMonthsRent: sources.value.firstMonthsRent.firstMonthsRent.total,
      vatOnOpeningFee: sources.value.firstMonthsRent.vatOnOpeningFee.total,
      partialDayInterest: sources.value.partialDayInterest.partialDayRent.total,
      partialDayInterestVat:
        sources.value.partialDayInterest.partialDayVAT.total,
    };

    const totalConceptos = computed(
      () =>
        conceptos.servicerFeeOpening +
        conceptos.servicerFeeOpeningVat +
        conceptos.firstMonthsRent +
        conceptos.vatOnOpeningFee +
        conceptos.partialDayInterest +
        conceptos.partialDayInterestVat
    );

    const totales = {
      equipment: conceptos.paymentToOEM + conceptos.vatOnEquipment,
      totalFeesPaidToServicer: totalConceptos,
      totalUses:
        conceptos.paymentToOEM +
        conceptos.vatOnEquipment +
        totalConceptos.value,
    };

    return {
      conceptos,
      totales,
    };
  });

  return {
    uses,
  };
});

export default useCotizacionEstandarUsesStore;
